<template>
  <action-dispatcher
    class="view-blog-article"
    action="blog/getArticle"
    :parameters="$route.params.id"
  >
    <div v-if="article && article.id" class="container py-5">
      <h3 class="text-center text-uppercase">{{ article.title }}</h3>
      <div class="d-flex justify-content-center align-items-center">
        <i class="icon-clock mr-2"></i> {{ readSpeed }} minutos de leitura
      </div>
      <div
        class="img-cover my-5"
        :style="`background-image: url(${article.cover})`"
      ></div>
      <div
        class="text-light article-description"
        v-html="article.description"
      />
    </div>
  </action-dispatcher>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("blog", ["article"]),
    readSpeed() {
      const wordsPerMinute = 250;
      const lettersPerWord = 4.5;
      return Math.ceil(
        get(this.article, "description", "").length /
          (wordsPerMinute * lettersPerWord)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.view-blog-article {
  .img-cover {
    width: 100%;
    height: 0;
    padding-bottom: 40%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
  }

  .article-description {
    ::v-deep * {
      color: #f8f9fa !important;
      background: none !important;
    }
  }
}
</style>
